import { useSyncExternalStore } from 'react'
import type { ColorScheme } from './use-color-scheme.js'

const readScheme = (): ColorScheme =>
  typeof document !== 'undefined' && document.documentElement.classList.contains('dark') ? 'dark' : 'light'

const subscribe = (onChange: () => void) => {
  if (typeof MutationObserver === 'undefined' || typeof document === 'undefined') {
    return () => undefined
  }
  const observer = new MutationObserver(onChange)
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
  return () => observer.disconnect()
}

/**
 * The color scheme the document actually has: the `dark` class on <html>, which is what tokens.css styles.
 *
 * For anything that reads resolved colours to draw (a canvas, an SVG renderer), and so must redraw on a theme
 * toggle (GH #2557). It changes only once the class is on the root, so a redraw reads the new colours. The store's
 * colorScheme (useTunaColorScheme) changes first and the class follows in an effect, which runs after a child's
 * effects: a child redrawing on the store value read the old colours.
 */
export const useAppliedColorScheme = (): ColorScheme => useSyncExternalStore(subscribe, readScheme, () => 'light')
